export const ERROR_MEMBERSHIP = {
  ERROR_NOT_FOUND$: 'ERROR_NOT_FOUND$',
  ERROR_FORBIDDEN$: 'ERROR_FORBIDDEN$',
  ERROR_INTERNAL_SERVER_ERROR$: 'ERROR_INTERNAL_SERVER_ERROR$',
  ERROR_EXPIRED_TOKEN$: 'ERROR_EXPIRED_TOKEN$',
} as const;
